import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const {
	colors,
	common: { border },
	spacing,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		height: 50,
	},
	extraTags: {
		background: 'white',
		border,
		borderRadius: 3,
	},
	extraTagsItem: {
		':not(:last-of-type)': {
			borderBottom: border,
		},
		alignItems: 'center',
		display: 'flex',
		fontSize: 12,
		padding: '3px 10px',
	},
	filterPill: {
		':nth-child(1n)': {
			margin: 4,
		},
	},
	moreTags: {
		':hover': {
			textDecoration: 'none',
		},
	},
	tag: {
		alignItems: 'center',
		display: 'flex',
	},
	tagTokenOpPrefix: {
		color: colors.text.dark,
	},
	categoryFilter: {
		marginLeft: spacing.sm,
	},
	backButton: {
		alignItems: 'center',
		display: 'flex',
		marginRight: spacing.md,
		':hover': {
			opacity: 0.8,
		},
	},
	backIcon: {
		marginRight: spacing.xs,
		width: 16,
		height: 16,
		transform: 'rotate(180deg)',
	},
	backText: {
		color: colors.text.main,
		fontSize: 14,
	},
	categoryName: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		marginRight: spacing.lg,
	},
	categoryIcon: {
		marginRight: spacing.xs,
		width: 20,
		height: 20,
	},
	categoryNameText: {
		color: colors.text.main,
		fontSize: 16,
		fontWeight: 600,
	},
});
